export default __webpack_public_path__ + "static/media/pic1.fc9cff58.jpg";